import $axios from 'axios'
import {
  consultantCompanyUrl,
  searchCompanyUrl,
  goodAtDirectionUrl,
  getEmailCodeUrl,
  bindConsultantCompanyUrl,
  companyInfoVerifyUrl,
  companyInfoRedisplayUrl,
  companyCertificationLinkUrl,
  companyAuthStatusUrl,
  companyAuthorizationLinkUrl,
  companyAuthorizationInformationUrl,
  legalPersonAuthUrl,
  contractLinkUrl,
  contractSignStatusUrl,
  abandonRegisterUrl,
  userDetailUrl,
  companyAuthorizationStatusUrl,
  checkCompanyAuthUrl,
  checkEmailCode,
  realNameIdentify,
  getBusinessTypeUri,
  getPersonalCenterFunctionInfoUri,
  industryInfoUri,
  GET_CITY_LIST_URI,
} from '../config/uri'
// 查询猎企（绑定猎企时使用）
export function getConsultantCompany(params) {
  return $axios.post(consultantCompanyUrl, params)
}

// 天眼查查询公司注册信息（创建新客户）
export function getSearchCompany(params) {
  return $axios.post(searchCompanyUrl, params)
}

// 擅长方向标签
export function getGoodAtDirection(params) {
  return $axios.post(goodAtDirectionUrl, params)
}

// 获取邮箱验证码
export function getGetEmailCode(params) {
  return $axios.post(getEmailCodeUrl, params)
}

// 绑定猎企
export function getBindConsultantCompany(params) {
  return $axios.post(bindConsultantCompanyUrl, params)
}

// 猎企信息校验
export function getCompanyInfoVerify(params) {
  return $axios.post(companyInfoVerifyUrl, params)
}

// 猎企绑定
export function getCheckCompanyAuth(params) {
  return $axios.post(checkCompanyAuthUrl, params)
}

// 获取完善信息页面回显数据
export function getCompanyInfoRedisplay(params) {
  return $axios.post(companyInfoRedisplayUrl, params)
}

// 获取企业认证链接
export function getCompanyCertificationLink(params) {
  return $axios.post(companyCertificationLinkUrl, params)
}

// 获取企业认证结果
export function getCompanyAuthStatus(params) {
  return $axios.post(companyAuthStatusUrl, params)
}

// 禾蛙企业授权链接-----------------------1
export function getCompanyAuthorizationLink(params) {
  return $axios.post(companyAuthorizationLinkUrl, params)
}

// 获取企业授权信息-----------------------2
export function getCompanyAuthorizationInformation(params) {
  return $axios.post(companyAuthorizationInformationUrl, params)
}

// 法人验证-----------------------3
export function getLegalPersonAuth(params) {
  return $axios.post(legalPersonAuthUrl, params)
}

// 获取签署合同链接-----------------------4
export function getContractLink(params) {
  return $axios.post(contractLinkUrl, params)
}

// 获取合同签署结果-----------------------5
export function getContractSignStatus(params) {
  return $axios.post(contractSignStatusUrl, params)
}

// 放弃注册-----------------------6
export function getAbandonRegister(params) {
  return $axios.post(abandonRegisterUrl, params)
}

// 获取顾问信息-----------------------7
export function getUserDetail(params) {
  return $axios.post(userDetailUrl, params)
}

// 获取企业认证授权结果-----------------------7
export function getCompanyAuthorizationStatus(params) {
  return $axios.post(companyAuthorizationStatusUrl, params)
}

// 获取企业认证授权结果-----------------------7
export function getCheckCompanyAuthStatus(params) {
  return $axios.post(checkCompanyAuthUrl, params)
}

// 提交邮箱-----------------------7
export function getCheckEmailCode(params) {
  return $axios.post(checkEmailCode, params)
}

// 提交实名-----------------------7
export function getRealNameIdentify(params) {
  return $axios.post(realNameIdentify, params)
}

// 擅长职能
export function getPersonalCenterFunctionInfo(params) {
  return $axios.post(getPersonalCenterFunctionInfoUri, params)
}

// 擅长业务类型
export function getBusinessType(params) {
  return $axios.post(getBusinessTypeUri, params)
}

// 擅长行业
export function getIndustryInfo(params) {
  return $axios.post(industryInfoUri, params)
}
// 擅长城市
export function getCityList(params) {
  return $axios.post(GET_CITY_LIST_URI, params)
}
